<template>
  <div>
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="7">
          <div class="text-h3 font-weight-medium pink--text"><v-img src="@/assets/logo.png" width="300" /></div>
          <div class="font-weight-bold text-h4 my-2">Página não encontrada</div>
          <div>Nós não encontramos a página que você está procurando.</div>
          <div>
            Você pode voltar a página inicial e tentar novamente ou entre em
            contato com <br/>a nossa equipe de suporte
          </div>
          <div>
            <v-btn small outlined dark class="mt-2" color="#4B2A66" :to="{ name: 'home' }" exact
              >Página Inicial</v-btn
            >
            <v-btn small outlined dark class="mx-2 mt-2" color="#4B2A66" :to="{ name: 'support' }" exact
              >Contate-nos</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  mounted () {
    document.title = `Olhadela - Página não encontrada`
  }
}
</script>